import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/site-map`;

const siteMapService = {
  get: (facilityId) => apiClient.get(`${base(facilityId)}/`),
  save: (facilityId, payload) => apiClient.put(`${base(facilityId)}/`, payload),
  quickRent: (facilityId, unitId, payload) =>
    apiClient.post(`${base(facilityId)}/units/${unitId}/quick-rent`, payload),
  unitNotes: (facilityId, unitId) =>
    apiClient.get(`/api/facilities/${facilityId}/units/${unitId}/notes`),
  // formData: { body: string, files: File[] } — one multipart POST writes
  // the note to the unit history AND mirrors it to the tenant's notes.
  addUnitNote: (facilityId, unitId, body, files = []) => {
    const fd = new FormData();
    fd.append('body', body);
    files.forEach((f) => fd.append('files', f));
    return apiClient.post(
      `/api/facilities/${facilityId}/units/${unitId}/notes`, fd,
    );
  },
};

export default siteMapService;
